import { Dispatch, SetStateAction } from 'react';
import { useNavigate } from 'react-router-dom';

import { useSearchParams } from '@popularKeyword/common-hooks';

type PaginationProps = {
  setPage: Dispatch<SetStateAction<number>>;
};

const Pagination = ({ setPage }: PaginationProps) => {
  const navigate = useNavigate();
  const ITEM_COUNT_PER_PAGE = 400;
  const MIN_PAGE = 0;

  const { rising, category, page, date, total } = useSearchParams();

  const maxPage = total ? Math.ceil(total / ITEM_COUNT_PER_PAGE) - 1 : 3;

  const currentPage = Number(page);

  const getRoutingPath = (page: number) => {
    return rising === 'true'
      ? `?domain=pc&type=detail&rising=true&page=${page}&total=${total}`
      : `?domain=pc&type=detail&rising=false&page=${page}&total=${total}&category=${category}${
          date ? `&date=${date}` : ''
        }`;
  };

  const onClickPrevButton = async () => {
    if (currentPage <= MIN_PAGE) return;
    const routingPath = getRoutingPath(currentPage - 1);

    setPage((prev) => prev - 1);
    navigate(routingPath);
  };

  const onClickNextButton = async () => {
    if (currentPage >= maxPage) return;
    const routingPath = getRoutingPath(currentPage + 1);

    setPage((prev) => prev + 1);
    navigate(routingPath);
  };

  return (
    <nav className="c_pagination c_pagination_style_3" aria-label="급상승 인기 키워드">
      <p className="page">
        <strong aria-label="현재페이지"> {currentPage + 1}</strong>
        <span className="sr-only">전체 페이지</span>
        {maxPage + 1}
      </p>
      <p className="navigator">
        <button className="previous" type="button" disabled={currentPage === MIN_PAGE} onClick={onClickPrevButton}>
          이전
        </button>
        <button className="next" type="button" disabled={currentPage === maxPage} onClick={onClickNextButton}>
          다음
        </button>
      </p>
    </nav>
  );
};

export default Pagination;
